module.exports = __webpack_public_path__ + "img/m-hd.75ab550c.jpg";